<!--  -->
<template>
  <div class="page" :class="{ inApp: $root.$data.isApp || this.$root.miniprogram }">
    <common-title titleName="学情调研" :zIndex="1000"></common-title>
    <div class="section">
      <div class="list school">
        <h1><b>目标院校及专业</b><span>*</span></h1>
        <input
          @click="openSelected(1)"
          v-model="school"
          type="text"
          placeholder="请填写目标院校及专业(未定填“未定”即可)"
        />
        <p class="error" v-if="showError && currentType === 1">
          请填写目标院校及专业
        </p>
      </div>
      <div class="list">
        <h1><b>学员性质</b><span>*</span></h1>
        <input
          @click="openSelected(2)"
          v-model="onceAgain.name"
          readonly
          type="text"
          placeholder="请选择"
        />
        <p class="error" v-if="showError && currentType === 2">请选择学员性质</p>
      </div>
      <div class="list">
        <h1><b>考试科目</b><span>*</span></h1>
        <input
          @click="openSelected(3)"
          v-model="subject"
          type="text"
          placeholder="例：数一英一政治+专业课"
        />
        <p class="error" v-if="showError && currentType === 3">请填写考试科目</p>
      </div>
      <div class="list">
        <h1><b>目前数学学习情况</b><span>*</span></h1>
        <input
          @click="openSelected(4)"
          v-model="learningMath.name"
          readonly
          type="text"
          placeholder="请选择"
        />
        <p class="error" v-if="showError && currentType === 4">请选择目前数学学习情况</p>
      </div>
      <div class="list">
        <h1><b>目前英语学习情况</b><span>*</span></h1>
        <input
          @click="openSelected(5)"
          v-model="learningEnglish.name"
          readonly
          type="text"
          placeholder="请选择"
        />
        <p class="error" v-if="showError && currentType === 5">请选择目前英语学习情况</p>
      </div>
      <div class="list">
        <h1><b>政治是否已启动学习</b><span>*</span></h1>
        <input
          @click="openSelected(6)"
          v-model="learningPolitics.name"
          readonly
          type="text"
          placeholder="请选择"
        />
        <p class="error" v-if="showError && currentType === 6">请选择政治是否已启动学习</p>
      </div>
      <div class="list">
        <h1><b>目前认为最薄弱的学科</b><span>*</span></h1>
        <input
          @click="openSelected(7)"
          v-model="weaknessSubject.name"
          readonly
          type="text"
          placeholder="请选择"
        />
        <p class="error" v-if="showError && currentType === 7">请选择目前认为最薄弱的学科</p>
      </div>
      <div class="list">
        <h1><b>目前一天的学习时长</b><span>*</span></h1>
        <input
          @click="openSelected(8)"
          v-model="learningTime.name"
          readonly
          type="text"
          placeholder="请选择"
        />
        <p class="error" v-if="showError && currentType === 8">请选择目前一天的学习时长</p>
      </div>
    </div>
    <div class="foot" @click="submit">
      <div>提交</div>
    </div>
    <MultipleSelect ref="multiple" @selectRes="selectRes" :currentSelect="currentSelect" />
    <SingleSelect ref="single" @selectRes="selectRes" :currentSelect="currentSelect" />
  </div>
</template>

<script>
import { reqLearnSurvey } from '@/api/trainEntrance/index';
import MultipleSelect from './component/multipleSelect.vue';
import SingleSelect from './component/singleSelect.vue';
import selectList from './selectList';
import wx from 'weixin-js-sdk';

export default {
  components: {
    MultipleSelect,
    SingleSelect,
  },
  data() {
    return {
      selectList,
      school: '',
      onceAgain: {},
      subject: '',
      learningMath: {},
      learningEnglish: {},
      learningPolitics: {},
      weaknessSubject: {},
      learningTime: {},
      currentType: 0,
      currentSelect: [],
      showError: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    openSelected(type) {
      console.log(type);
      if (type === 1 || type === 3) return;
      this.currentSelect = this.selectList[type] || [];
      this.currentType = type;
      if (type === 7) {
        this.$refs.multiple.show = true;
      } else {
        this.$refs.single.show = true;
      }
    },
    selectRes(data) {
      if (this.currentType === 7) {
        const temp = this.selectList[this.currentType];
        Object.assign(this.selectList, { [this.currentType]: temp });
      } else {
        const { value } = data;
        const temp = this.selectList[this.currentType];
        temp.forEach((element) => {
          if (element.value === value) {
            Object.assign(element, { checked: true });
          } else {
            Object.assign(element, { checked: false });
          }
        });
        Object.assign(this.selectList, { [this.currentType]: temp });
      }

      if (this.currentType === 2) {
        this.onceAgain = data;
      }
      if (this.currentType === 4) {
        this.learningMath = data;
      }
      if (this.currentType === 5) {
        this.learningEnglish = data;
      }
      if (this.currentType === 6) {
        this.learningPolitics = data;
      }
      if (this.currentType === 7) {
        const filterRes = data.filter((ele) => ele.checked);
        const name = filterRes.map((ele) => ele.name);
        const value = filterRes.map((ele) => ele.value);
        this.weaknessSubject = { name, value: value.toString() };
      }
      if (this.currentType === 8) {
        this.learningTime = data;
      }
      setTimeout(() => {
        if (this.currentType === 7) {
          this.$refs.multiple.show = false;
        } else {
          this.$refs.single.show = false;
        }
      }, 100);
    },
    checkSubmit() {
      console.log(1120);
      if (!this.school) {
        this.showError = true;
        this.currentType = 1;
        return true;
      }
      if (!this.onceAgain.value) {
        this.showError = true;
        this.currentType = 2;
        return true;
      }
      if (!this.subject) {
        this.showError = true;
        this.currentType = 3;
        return true;
      }
      if (!this.learningMath.value) {
        this.showError = true;
        this.currentType = 4;
        return true;
      }
      if (!this.learningEnglish.value) {
        this.showError = true;
        this.currentType = 5;
        return true;
      }
      if (!this.learningPolitics.value&&this.learningPolitics.value!==0) {
        this.showError = true;
        this.currentType = 6;
        return true;
      }
      if (!this.weaknessSubject.value) {
        this.showError = true;
        this.currentType = 7;
        return true;
      }
      if (!this.learningTime.value) {
        this.showError = true;
        this.currentType = 8;
        return true;
      }
      console.log(11110);
    },
    async submit() {
      if (this.checkSubmit()) return;
      const params = {
        englishLearningSituation: this.learningEnglish.value,
        isMultipleTimes: this.onceAgain.value,
        learnDesc: this.learningTime.value,
        mathLearningSituation: this.learningMath.value,
        politicsLearningSituation: this.learningPolitics.value,
        tgSchoolMajor: this.school,
        tgSubject: this.subject,
        weakSubject: this.weaknessSubject.value,
      };
      const { code, msg } = await reqLearnSurvey(params);
      if (code===0) {
        this.$toast('提交成功');
        setTimeout(()=>{
          this.livePage();
        },2000)
      } else {
        this.$toast(msg);
      }
    },
    livePage() {
      if (this.$root.isApp) {
        this.$sendToApp('closePage');
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/myCourse/courseList/index`,
        });
        return;
      }
      this.$router.push({
        path: '/personalCenter/mycourseList',
        query: {
        },
      });
    },
  },
  created() {},
  mounted() {
    document.title = '学情调研';
  },
};
</script>
<style lang="scss" scoped>
.inApp {
  padding-top: 20px !important;
}
.page {
  width: 100%;
  height: 100%;
  padding: 142px 36px 180px 36px;
  background: #f9f9f9;
  .section {
    width: 100%;
    padding: 36px 29px;
    background: #fff;
    border-radius: 14px;
    .school.list {
      margin-top: 0;
    }
    .list {
      margin-top: 11px;
      h1 {
        padding-bottom: 14px;
        b {
          color: #333;
          font-weight: 500;
          font-size: 25px;
        }
        span {
          position: relative;
          top: 16px;
          color: #ff3938;
        }
      }
      input {
        width: 620px;
        height: 87px;
        margin-bottom: 7px;
        padding: 0 22px;
        color: #333;
        font-weight: 500;
        font-size: 25px;
        background: #f5f6f7;
        border-radius: 14px;
        &::placeholder {
          color: #999;
          font-weight: 400;
          font-size: 25px;
        }
      }
      .error {
        color: #ff3938;
        font-weight: 400;
        font-size: 22px;
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 750px;
    height: 167px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4px 14px 0 rgba(0, 0, 0, 0.05);
    div {
      width: 678px;
      height: 80px;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
}
</style>
